// extracted by mini-css-extract-plugin
module.exports = {"icon":"GenderBadge_icon__2Ok_f","BaseMale":"GenderBadge_BaseMale__2FhHJ","BaseFemale":"GenderBadge_BaseFemale__aY504","Unisex":"GenderBadge_Unisex__3ufZA"};